import React, { useState, useEffect } from 'react';
import { Modal } from 'antd-v5';
import { notificationError, notificationSuccess } from '../../../../core/actions';
import { getRequest, postRequest } from '../../../../core/apiRequests';
import DropdownSelect from '../../../Layout/DropdownSelect';
import { setFirstName, setLastName } from '../../../../reducers/associate';

const ReassignAssociateModal = props => {
  const [associateList, setAssociateList] = useState([]);
  const [associateID, setAssociateID] = useState('');

  useEffect(() => {
    if (props.merchantId) {
      if (props.storeObjs) {
        const reqObj = {
          params: ['associates', props.merchantId, 'getAllAssociateList'],
        };
        (async () => {
          const data = await getRequest(reqObj);
          const tempAssocList = [
            {
              name: 'No Associate',
              id: 0,
            },
          ];
          if (data) {
            data.map(assoc => {
              tempAssocList.push({
                name: `${assoc.first_name} ${assoc.last_name || ''}`,
                id: assoc.id,
              });
            });
          }
          setAssociateList(tempAssocList);
        })();
      }
    }
  }, [props.merchantId, props.storeObjs]);

  return (
    <Modal
      title={`Are you sure you want to remove "${props.associate.firstName || ''} ${props.associate.lastName || ''}"?`}
      open
      onCancel={() => props.toggleReassignAssoc(false)}
      onOk={() => props.confirmDelete(associateID)}
      okText="Confirm"
      destroyOnClose
      width={430}
      centered
    >
      <span style={{ display: 'block', textAlign: 'left', width: '100%', paddingTop: '10px' }}>
        Reassign {`${props.associate.firstName || ''}'s`} clients to:
      </span>
      <DropdownSelect
        classProps="w-100-P m-top-8 align-left"
        options={associateList.map(associate => ({
          label: associate.name,
          value: associate.id,
        }))}
        placeholder="Choose an associate..."
        value={associateID}
        onChange={obj => setAssociateID(obj.value)}
        optionalStyles={{
          menuList: (provided, state) => ({
            ...provided,
            maxHeight: '100px',
          }),
        }}
      />
    </Modal>
  );
};

export default ReassignAssociateModal;
